import { useAppDispatch, useAppSelector } from 'store'
import { useEffect, useState } from 'react'
import {
  reset,
  fetchGetSupplyOrderDetail,
  fetchGetSupplyOrderDetailItem,
} from 'features/SupplyOrder/redux/outboundSODetail'
import { useHistory, useParams } from 'react-router-dom'
import { Button } from '@astro-ui/components'
import { fetchPutSupplyOrderStatus } from 'features/SupplyOrder/redux/outboundSO'
import { toastSuccess } from 'utils/toast'
import ActivityStaff from './ActivityStaff'
import ActivityStatus from './ActivityStatus'
import BasicDetail from './BasicDetail'
import Layout from './Layout'
import ProductDetail from './ProductDetail'
import RightPanel from './RightPanel'
import { useRBACOutboundSODetailPage } from './rbac'

const OutboundSODetail = () => {
  const history = useHistory()
  const { id } = useParams<{ id: string }>()

  const [isSubmitLoading, setIsSubmitLoading] = useState(false)

  const dispatch = useAppDispatch()
  const isLoading = useAppSelector((state) => state.outboundSODetail.isLoading) || isSubmitLoading
  const isCreatedStatus = useAppSelector(
    (state) => state.outboundSODetail.data?.supplyOrderStatus.toLowerCase() === 'created',
  )

  const { isAllowedForMenuItemConfirm } = useRBACOutboundSODetailPage()

  const handleConfirm = async () => {
    try {
      setIsSubmitLoading(true)
      await dispatch(
        fetchPutSupplyOrderStatus({
          supplyOrderId: Number(id),
          payload: {
            status: 'NEW',
          },
          onSuccess: () => {
            toastSuccess('Supply Order berhasil di Confirm')
            history.push('/dashboard/outbound-so')
          },
        }),
      ).unwrap()
    } catch (err) {
      //
    } finally {
      setIsSubmitLoading(false)
    }
  }

  useEffect(() => {
    dispatch(fetchGetSupplyOrderDetail(Number(id)))
    dispatch(
      fetchGetSupplyOrderDetailItem({
        supplyOrderId: Number(id),
        params: {
          pageIndex: 0,
        },
      }),
    )

    return () => {
      dispatch(reset())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout
      isLoading={isLoading}
      RightPanel={<RightPanel />}
      RightHeader={
        isCreatedStatus && isAllowedForMenuItemConfirm ? (
          <Button width={164} onClick={handleConfirm}>
            Confirm
          </Button>
        ) : null
      }
    >
      <BasicDetail />
      <ProductDetail />
      <ActivityStatus />
      <ActivityStaff />
    </Layout>
  )
}

export default OutboundSODetail
